<template>
  <v-container>
    <ResourceDialog
      @save="save"
      ref="termsAgreementDialog"
      :cancellable="false"
      :max-width="800"
      :processing="processing"
      :save-button-text="termsAgreement.accept_label"
      :title="termsAgreement.title"
      center-title
    >
      <template #form>
        <SafeHtml
          :html="termsAgreement.content"
          class="pa-4"
        />
      </template>
    </ResourceDialog>
  </v-container>
</template>

<script setup>
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';

import ResourceDialog from '@/shared/components/form/ResourceDialog.vue';
import SafeHtml from '@/shared/components/SafeHtml.vue';
import useApi from '@/shared/composables/useApi';
import useEventBus from '@/shared/composables/useEventBus';

const { api: Api } = useApi();
const eventBus = useEventBus();
const route = useRoute();
const router = useRouter();
const store = useStore();

const processing = ref(false);
const termsAgreement = ref(store.state.config.terms_agreement);
const termsAgreementDialog = ref(null);

function load() {
  termsAgreementDialog.value.open({});
}

async function save() {
  processing.value = true;

  const resp = await Api.member.profile
    .update({
      terms_agreement_id: termsAgreement.value.id,
    })
    .catch((error) => eventBus.error(error));

  if (!resp?.data) return;

  store.commit('setProfile', resp.data);

  // Redirect to original destination if provided
  if (route.query.redirect_url) {
    await router.replace(route.query.redirect_url);
  } else {
    await router.replace({ name: 'Dashboard' });
  }
}

onMounted(load);
</script>
